import { api } from "@/lib/api";

// Featured Professionals attribution (fire-and-forget; impressions/views deduped per session).
export const SRC_PLACEMENT = {
  featured_home: "HOME_FEATURED_PROFESSIONALS",
  spotlight: "CONNECTIONS_PROFESSIONAL_SPOTLIGHT",
  featured_market: "MARKETPLACE_FEATURED_PROFESSIONALS",
};
const ONCE = new Set(["impression", "profile_view"]);

export function trackFeatured(event, campaignId, placement) {
  if (!campaignId || !placement) return;
  const key = `fp:${event}:${campaignId}`;
  if (ONCE.has(event)) {
    try { if (sessionStorage.getItem(key)) return; sessionStorage.setItem(key, "1"); } catch { /* ignore */ }
  }
  api.post("/ads/event", { campaign_id: campaignId, placement, event }).catch(() => {});
}

// Profile destination for a featured card; `inquire` opens the profile's inquiry dialog.
export function featuredHref(c, inquire = false) {
  const e = c.entity || {};
  const base = e.cta_destination || e.public_profile_path || "";
  if (!base) return "";
  return inquire ? `${base}${base.includes("?") ? "&" : "?"}inquire=1` : base;
}

// Fair-rotation window pinned per browser session (server validates ≤ 6h old).
const RW_KEY = "fp:rw";
export async function fetchFeatured(params) {
  let rw = null;
  try { rw = sessionStorage.getItem(RW_KEY); } catch { /* ignore */ }
  const { data } = await api.get("/ad-campaigns", { params: rw ? { ...params, rw } : params });
  if (data?.rotation_window != null && String(data.rotation_window) !== rw) {
    try { sessionStorage.setItem(RW_KEY, String(data.rotation_window)); } catch { /* ignore */ }
  }
  return (data?.campaigns || []).filter((c) => c.entity);
}
